export default {
  en: {
    id: 'exercise6',
    subtitle: 'SUGGESTED STRUCTURE <br> PCI ENERGY SERVICES GROUP',
    blocks: [
      {
        task: 'Want to grow in China. Difficult to develop compelling business case, whether to allocate selling expenses or not.',
        title: "S = ",
        answer: ' ',
        note: '',
        disableEdit: true
      },
      {
        task: 'Not so in other emerging markets.',
        title: "C = ",
        answer: ' ',
        note: 'Sol, R2',
        disableEdit: true
      },
      {
        task: 'Is this inherent characteristic of Chinese pharma market? How improve profitability and performance in China?',
        title: "Q = ",
        answer: ' ',
        disableEdit: true
      }
    ],
    image: '5d6-3.png',
    withoutAnswers: true,
    hideTaskTitle: true,
    submitButton: 'switch',
    note: 'Would that Slade had sent the R FP in this form.  But even if it didn’t, your turning it into this form gives a tactful way to enlighten them on what they really want to know, and to see reasonable parameters for how you will help them.'
  },
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/5/5d/writingProposalsPlans/i18n/exercise6.js